<!-- zym.连续型电子出版物 - 提交 -->
<template>
  <div class="press-7">
    <!-- <div class="headBar"> -->
    <!-- <span>连续型电子出版物出版情况登记表</span> -->
    <!-- zym.20241105，注释掉年份了 -->
    <!-- <el-select v-model="selYearLxdz" @change="valChange" size="medium" placeholder="历年记录" style="float: right">
        <el-option v-for="item in selYearRecord" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select> -->
    <!-- </div> -->
    <div class="tipsCage">
      <span
        >注：出版物基本信息可使用EXCEL进行批量导入。使用批量导入功能前，需要先下载“导入模板”，并直接使用下载的“导入模板”文件按其规定格式填写后才能批量导入到系统里；</span
      >
    </div>
    <div class="ctrlsLine">
      <el-input v-model="tabPost.keyword" size="small" placeholder="通过导入编码、出版物中文名称查询"></el-input>
      <!-- <el-button class="seekBtn" @click="goSeek" size="small">查询</el-button> -->

      <a href="javascript:void(0);" @click="dmyfile" download>
        <el-button size="small">下载导入模板</el-button>
      </a>
      <el-button v-if="modifyFlag" @click="ExcelHandler" type="primary" size="small">导入Excel</el-button>
      <a :href="fileUrl" download>
        <el-button size="small">下载封面和盖章页</el-button>
      </a>
      <!-- <el-button v-if="modifyFlag" @click="toPvc" type="danger" size="small">整体提交</el-button> -->
      <ExcelIn
        ref="ExcelSet"
        @t-frash="goFresh"
        @excel-errors="errorCtrls"
        pressType="3"
        :pressId="pressId"
        excelCode="401" />
    </div>
    <div class="headBar">
      <span>材料1：出版单位基本信息、人员信息</span>
    </div>
    <div class="editArea">
      <el-table border :data="tabDatCommon" style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="materialTitle" label="材料名称" align="center"> </el-table-column>
        <el-table-column label="完成进度" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.code == '402'">{{ scope.row.table2Status | transStr("tabsta") }}</span>
            <span v-if="scope.row.code == '404'">{{ scope.row.table4Status | transStr("tabsta") }}</span>

            <!-- {{ scope.row.status == "0" ? "未完成" : "已完成" }} -->
          </template>
        </el-table-column>
        <el-table-column label="更新时间" align="center">
          <template slot-scope="scope">
            {{ scope.row | translate("time") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button v-if="!modifyFlag" @click="toEdit(scope.row, 2)" type="primary" size="mini">查看</el-button>
            <el-button
              v-if="modifyFlag && scope.row.statuspom == 1"
              @click="toEdit(scope.row, 1)"
              type="primary"
              size="mini"
              >填表</el-button
            >
            <el-button
              v-if="modifyFlag && scope.row.statuspom != 1"
              @click="toEdit(scope.row, 2)"
              type="danger"
              size="mini"
              >修改</el-button
            >
            <a v-if="!modifyFlag && scope.row.code == '404'" href="javascript:void(0);" @click="expFullFile(scope.row)">
              <el-button size="mini">导出打印表</el-button>
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="headBar">
      <span>材料2：出版物信息</span>
    </div>
    <div class="editArea">
      <el-table :data="tabDat" border style="width: 100%; margin-top: 0px" v-loading="loading">
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 + 15 * (tabPost.no - 1) }}
          </template>
        </el-table-column>
        <el-table-column width="120" prop="materialCode" label="导入编码" align="center"></el-table-column>
        <el-table-column prop="materialTitle" label="出版物中文名称" align="center"></el-table-column>
        <el-table-column label="出版物基本信息" align="center">
          <template slot-scope="scope">
            {{ scope.row.table1Status | transStr("tabsta") }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="单位基本信息" align="center">
          <template slot-scope="scope">
            {{ scope.row.table2Status | transStr("tabsta") }}
          </template>
        </el-table-column> -->
        <el-table-column label="出版经营情况" align="center">
          <template slot-scope="scope">
            {{ scope.row.table3Status | transStr("tabsta") }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="人员基本信息" align="center">
          <template slot-scope="scope">
            {{ scope.row.table4Status | transStr("tabsta") }}
          </template>
        </el-table-column> -->
        <el-table-column label="出版经营情况调查表" align="center">
          <template slot-scope="scope">
            {{ scope.row.table5Status | transStr("tabsta") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="190" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              v-if="
                scope.row.flowName == '省局' ||
                scope.row.flowName == '国家新闻出版署' ||
                (scope.row.flowName == '开始' && !transCode(scope.row))
              "
              @click="goComTab(scope.row)"
              size="mini">
              <span v-if="scope.row.flowName == '省局' || scope.row.flowName == '国家新闻出版署'">查看</span>
              <span v-if="scope.row.flowName == '开始' && transCode(scope.row)">修改</span>
              <span v-if="scope.row.flowName == '开始' && !transCode(scope.row)">填表</span>
            </el-button>

            <el-button
              type="danger"
              v-if="scope.row.flowName == '开始' && transCode(scope.row)"
              @click="goComTab(scope.row)"
              size="mini">
              <span v-if="scope.row.flowName == '开始' && transCode(scope.row)">修改</span>
            </el-button>
            <!-- <el-button size="mini" type="danger">打印</el-button> -->
            <a href="javascript:void(0);" @click="expLxJbxxFile(scope.row)">
              <el-button size="mini">导出打印表</el-button>
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pageArea" v-if="tabPost.total > 1">
      <el-pagination
        :current-page="tabPost.no"
        @current-change="pageChange"
        layout="prev, pager, next"
        :page-count="tabPost.total">
      </el-pagination>
    </div>

    <ExError ref="chinldError" :errorList="excelEr" pressCode="401"></ExError>

    <div class="subLine">
      <el-button v-if="modifyFlag" @click="toPvc" type="danger" size="small">提交</el-button>
      <!-- <el-button @click="copyHandle('show')" type="danger">拷贝</el-button> -->
    </div>
  </div>
</template>

<script>
import {
  getSuccessList,
  successTabSubmit,
  getSelYearRecordLxdz, // zym.年度选择
  getLxdzModifyFlagByOrganization, // zym.判断是否可以修改数据 - 连续型电子出版物列表
} from "@/api/pressRole/pressSuccessive";
import ExcelIn from "@/views/components/excelRead/excel";
import ExError from "@/views/components/excelRead/excelError";
import { expFile } from "@/api/export";
import { mapGetters } from "vuex";
export default {
  components: {
    ExcelIn,
    ExError,
  },
  data() {
    return {
      selYearLxdz: "",
      selYearRecord: [],

      tabDatAll: [],
      // 连续型电子出版物单位基本信息、人员基本信息
      tabDatCommon: [],
      tabDat: [],
      postId: "",
      pressId: [],
      excelEr: [],
      tabPost: {
        no: 1,
        size: 15,
        total: 0,
        keyword: "",
      },

      loading: false,

      uploadStorage: {},

      excelModeUrl: "",
      fileUrl: "",

      modifyFlag: false,
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  filters: {
    transStr: function (dat, code) {
      if (code == "tabsta") {
        let arrs = ["/", "已完成"];
        return arrs[dat - 1];
      }
    },
    translate: function (dat, code) {
      // if (code == "pgress") {
      //   let transArr = ["未提交", "已提交"];
      //   return transArr[dat - 1];
      // } else if (code == "time") {
      // if (dat.status == 2) {
      return dat.updatedatpom.substr(0, 16);
      // } else {
      //   return "";
      // }
      // }
    },
  },
  watch: {
    tabPost: {
      deep: true, //实现深度监听
      handler(v) {
        if (!v.goPage) {
          this.tabPost.no = 1;
        }
        this.tabPost.goPage = false;
        this.filterTableData();
      },
    },
  },
  methods: {
    expFullFile: function (material) {
      console.log("material=", material);
      var expUrl = "/api/export/printRyJbxx";
      var params = {
        type: 3,
        publishMaterialId: material.pomid,
      };
      expFile({ expUrl: expUrl, p: params })
        .then((blob) => {
          let blobHref = window.URL.createObjectURL(blob);
          let anchor = document.createElement("a");
          anchor.href = blobHref;
          var fname = localStorage.getItem("dfilename");
          anchor.download = decodeURIComponent(fname);
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(blobHref);
          document.body.removeChild(anchor);
        })
        .catch((error) => {});
    },
    expLxJbxxFile: function (row) {
      var expUrl = "/api/export/printLxJbxx";
      var params = {
        firstYear: row.firstYear,
        type: 3,
        publishMaterialId: row.id,
      };
      expFile({ expUrl: expUrl, p: params })
        .then((blob) => {
          let blobHref = window.URL.createObjectURL(blob);
          let anchor = document.createElement("a");
          anchor.href = blobHref;
          var fname = localStorage.getItem("dfilename");
          anchor.download = decodeURIComponent(fname);
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(blobHref);
          document.body.removeChild(anchor);
        })
        .catch((error) => {});
    },
    valChange: function () {
      // sessionStorage.setItem('selYearLxdz', this.selYearLxdz)
      // // zym.判断是否可以修改
      // this.pressTabs();
    },
    initYearArray: function () {
      // let that = this;
      // // zym.查询历史年份
      // getSelYearRecordLxdz({
      // }).then(response => {
      //   console.log("======", response);
      //   let arr = [];
      //   let historyYear = response.generalPublisher;
      //   if (historyYear && historyYear.length > 0) {
      //     for (let i = 0; i < historyYear.length; i++) {
      //       let po = historyYear[i];
      //       arr.push({ label: po.firstYear + '~' + po.secondYear, value: po.firstYear });

      //       if ((historyYear.length - 1) == i) {
      //         let cacheYear = sessionStorage.getItem('selYearLxdz');
      //         if (cacheYear) {
      //           that.selYearLxdz = cacheYear;
      //         }
      //         else {
      //           that.selYearLxdz = po.firstYear;
      //         }
      //       }
      //     }
      //   }
      //   that.selYearRecord = arr;

      //   // zym.年份初始化好了，再调用这个方法
      //   this.pressTabs();
      // })
      this.selYearLxdz = this.$store.getters.userInfo.year1;
      this.pressTabs();
    },
    goComTab: function (dat) {
      this.$router.push({
        path: "successive_tabs",
        query: {
          listId: dat.id,
          bookName: dat.materialTitle,
          mtcode: dat.materialCode,
          firstYear: this.selYearLxdz,
        },
      });
    },
    pressTabs: function () {
      this.loading = true;
      var vm = this;
      this.tabPost.selYearLxdz = this.selYearLxdz;
      getSuccessList(this.tabPost).then((response) => {
        this.loading = false;
        this.tabDatAll = response.flxdzOrganizationMaterialList;
        // zym.20241227，出版单位基本信息、人员信息
        this.tabDatCommon = response.flxdzOrganizationMaterialCommonList;
        this.modifyFlag = response.modifyFlag;
        console.log("modifyFlag=", this.modifyFlag);

        this.filterTableData();

        // 计算分页信息
        // vm.calPage();

        if (this.tabDat.length > 0) {
          this.postId = this.tabDat[0].materialExamineId;
        }

        for (let i = 0; i < this.tabDat.length; i++) {
          let temp = {
            psId: this.tabDat[i].organizationId,
            mtId: this.tabDat[i].id,
          };

          this.pressId.push(temp);
        }

        setTimeout(function () {
          getSuccessList({
            no: 1,
            size: 1000,
          }).then((response) => {
            var ssDat = response.flxdzOrganizationMaterialList;
            for (let i = 0; i < ssDat.length; i++) {
              vm.uploadStorage[ssDat[i].materialCode] = ssDat[i].materialExamineId;
            }
          });
        }, 1000);
      });
    },
    // zym.过滤列表数据
    filterTableData: function () {
      let tabDats = this.tabDatAll;
      let qKeyword = this.tabPost.keyword;

      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.materialTitle || "").indexOf(qKeyword) > -1 || (item.materialCode || "").indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function () {
      let tabPost = this.tabPost;
      let tabDatAll = this.tabDats;
      let dataLen = Number(tabDatAll.length);
      let size = Number(tabPost.size);
      let total = Math.floor(dataLen / size);
      this.tabDat = tabDatAll.slice((tabPost.no - 1) * size, tabPost.no * size);

      // console.log("tabDat=", JSON.stringify(this.tabDat));
      // console.log("dataLen=", dataLen);
      // console.log("size=", size);
      // console.log("dataLen-size=", dataLen % size);
      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      tabPost["total"] = total;
      this.tabPost = tabPost;
      console.log("this.tabPost=", JSON.stringify(this.tabPost));
    },
    pageChange: function (inx) {
      this.tabPost.no = inx;
      // this.pressTabs();
      this.tabPost.goPage = true;
    },
    // zym.20241227，单位基本信息、人员信息，
    toEdit: function (row, type) {
      let urlMap = {
        401: "edit_ssTab1", // pressRole/SuccessivePart/forEdit/ssTab1
        402: "edit_ssTab2", // pressRole/SuccessivePart/forEdit/ssTab2
        403: "edit_ssTab3", // pressRole/SuccessivePart/forEdit/ssTab3
        404: "sstab4_list", // pressRole/SuccessivePart/forTabs/ssTab4

        405: "edit_ssTab5", // pressRole/SuccessivePart/forTabs/ssTab4
      };
      this.$router.push({
        path: urlMap[row.code],
        query: {
          pressId: row.organizationId,
          mtId: row.pomid,
          pgress: type,

          listId: row.id, // zym.publishMaterialId

          bookName: row.materialTitle,
          mtcode: row.materialCode, // zym.materialCode 出版物的code编号
        },
      });
    },
    // zym.整体提交
    toPvc: function () {
      let vm = this;
      this.$confirm("确认提交至省局吗？", "提示", {
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          successTabSubmit().then((response) => {
            loading.close();

            // console.log('response=',JSON.stringify(response));
            let tipCode = response.payload.tipCode;
            let tipMessage = response.payload.message || "操作失败";
            if (tipCode == "fail") {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "error",
              });
            } else {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.$router.push("successive_step");
            }
          });
        })
        .catch((error) => {});
    },

    transCode: function (dat, showType) {
      return dat.table1Status == 2 && dat.table2Status == 2 && dat.table3Status == 2 && dat.table4Status == 2;
    },

    ExcelHandler: function () {
      if (this.uploadStorage) {
        this.$refs.ExcelSet.handleUpload(this.uploadStorage);
      } else {
        this.$message.error("初始化尚未完成，请稍后再试");
      }
    },

    errorCtrls: function (val) {
      this.excelEr = val;
      this.$refs.chinldError.handErrors();
    },

    goSeek: function () {
      this.tabPost.no = 1;
      this.pressTabs();
    },

    goFresh: function () {
      this.pressTabs();
    },
    dmyfile: function () {
      var expUrl = "/api/export/downloadLxdzmb";
      var params = {
        code: 401,
      };
      expFile({ expUrl: expUrl, p: params })
        .then((blob) => {
          let blobHref = window.URL.createObjectURL(blob);
          let anchor = document.createElement("a");
          anchor.href = blobHref;
          var fname = localStorage.getItem("dfilename");
          anchor.download = decodeURIComponent(fname);
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(blobHref);
          document.body.removeChild(anchor);
        })
        .catch((error) => {});
    },
  },

  created: function () {
    this.initYearArray();

    // this.getLxdzModifyFlagByOrganization();

    this.excelModeUrl =
      process.env.BASE_API + "/File/File/downloadLxdzmb?code=401&token=" + encodeURIComponent(this.token);
    //  this.fileUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=002&token=' + encodeURIComponent(this.token);
    this.fileUrl = process.env.URL_FILE + "/drmb/003.xlsx";
    // this.fileUrl = process.env.BASE_API + '/drmb/002.xlsx // 封面和盖章页';
  },
};
</script>

<style lang="scss">
.press-7 {
  padding: 0px 12px;
  font-size: 14px;

  .subLine {
    text-align: center;
    margin: 0 0 50px;

    .el-button {
      width: 180px;
      margin-top: 12px;
    }
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    margin-top: 9px;
    color: #666666;
  }

  .seekBtn {
    margin-right: 12px;
  }

  .tipsCage {
    font-size: 12px;
    color: #999999;
    padding: 12px;
  }

  .ctrlsLine {
    padding: 0px 12px;

    .el-input {
      width: 360px;

      input {
        border-radius: 0px;
      }
    }
  }

  .succedTips {
    font-size: 14px;
    color: #666666;
    padding: 20px;

    a {
      color: #409eff;
    }
  }

  .dvsWait {
    text-align: center;
    line-height: 240px;
    font-size: 24px;
    color: #999999;
  }

  .editArea {
    // padding: 12px;
    padding: 12px 0px;

    .el-button + .el-button {
      margin-left: 0px;
    }
  }

  .pageArea {
    text-align: center;
    padding: 24px 0px 45px;
  }
}
</style>



// WEBPACK FOOTER //
// successiveList.vue?44255e86